export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "process_line_exec_step": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paso de ejecución"])},
            "executed_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de ejecución"])},
            "observations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Observaciones"])},
            "process_line": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Línea de proceso"])},
            "finished_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de fin"])},
            "process_line_exec_inputs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productos de entrada"])},
            "process_line_exec_outputs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productos de salida"])},
            "process_line_exec_attrs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atributos de ejecución"])}
          }
        }
      }
    }
  })
}